<template lang="pug">
.LerpScroll: .wrapper: slot
</template>

<script>
import { lerp } from '@/assets/scripts/utils'

export default {
  name: 'LerpScroll',
  props: {
    speed: {
      type: Number,
      default: 0.9
    },
    amount: {
      type: Number,
      default: 0.2
    }
  },
  data() {
    return {
      scroll: 0,
      initialHeight: 0,
      isLandscape: window.innerHeight / window.innerWidth < 1
    }
  },
  methods: {
    animate() {
      this.scroll = lerp(this.scroll, window.scrollY * this.speed, this.amount)
      this.$el.querySelector(
        '.wrapper'
      ).style.transform = `translate3d(0, ${-this.scroll}px, 0)`
      requestAnimationFrame(this.animate)
    },
    do() {
      this.isLandscape = window.innerHeight / window.innerWidth < 1
      this.initialHeight = this.$el.querySelector('.wrapper').clientHeight
      if (this.isLandscape) {
        this.$el.querySelector('.wrapper').style.position = 'fixed'
        this.$el.style.height = this.initialHeight / this.speed + 'px'
        this.animate()
      } else {
        this.$el.querySelector('.wrapper').style.position = 'relative'
        this.$el.querySelector('.wrapper').style.transform = ''
        this.$el.style.height = 'auto'
      }
    }
  },
  mounted() {
    this.do()
    window.addEventListener('resize', this.do)
  }
}
</script>

<style lang="scss">
.LerpScroll {
  box-sizing: content-box;
}
</style>
